import React, { useContext } from 'react'
import DataTable from '@3mcom/mds-library/dist/node/DataTable'
import { Translations } from '../../services/TranslationService'
import { StateContext } from '../../services/StateService'
import { trackPDPData } from '../../services/TealiumService'
import { PDP_SELECTORS_ID } from '../../constants/PDPConstants'
import scrollService from '../../services/ScrollService'
import Spinner from '../../components/Spinner'

const TABLE_HEIGHT = '750px'
const TABLE_ROW_THRESHOLD = 6
const STICKY_COL_THRESHOLD = 6
const STICKY_VIEWPORT_WIDTH = 1440
const STICKY_COL_WIDTH = 200
const STICKY_FIRST_COL_WIDTH = 350
const STICKY_PADDING = 40

/**
 * Desktop view for Product Options table.
 * @param {Object} props
 * @param {Array} props.desktopCols - Column definitions for the table
 * @param {Array} props.desktopData - Row data for the table
 * @param {number} props.windowWidth - Current viewport width
 * @param {number} props.tableHeight - Height reference for spinner overlay
 * @param {Object} props.tableRef - Ref attached to the table wrapper div
 */
const ProductOptionsDesktop = ({
    desktopCols,
    desktopData,
    windowWidth,
    tableHeight,
    tableRef
}) => {
    const translations = useContext(Translations)
    const {
        moreOptions: { totalSelected },
        productOptions,
        selectedOptions,
        loadingProductOptions: { loading, isUpdate },
        matchingProductOptions,
        dispatch
    } = useContext(StateContext)

    if (!desktopData.length || !desktopCols.length) return null

    const matchingText = `${selectedOptions?.totalSelected} ${translations.matching} ${translations.of} ${totalSelected} ${translations.productOptions}`

    const tableContainerStyle =
        desktopData.length > TABLE_ROW_THRESHOLD ? { height: TABLE_HEIGHT } : undefined

    const freezeColumns = !!(
        desktopCols.length > STICKY_COL_THRESHOLD ||
        (windowWidth < STICKY_VIEWPORT_WIDTH &&
            (desktopCols.length - 1) * STICKY_COL_WIDTH + STICKY_FIRST_COL_WIDTH >
                windowWidth - STICKY_PADDING)
    )

    const handleCloseProductOptions = () => {
        dispatch({
            type: 'pdp_set_product_options',
            payload: {
                productOptions: [],
                moreOptions: { totalSelected: 0 },
                endpoint: ''
            }
        })
        dispatch({
            type: 'set_AJAX_errors',
            payload: {
                productOptionsAjaxError: false
            }
        })
        scrollService.scrollToSection(PDP_SELECTORS_ID)
        trackPDPData(
            `PDP Buying Zone Product Options Link Click: ${translations.closeSection}`,
            'Engagement Event'
        )
    }

    return (
        <>
            {loading && isUpdate && (
                <div
                    className="of sps2-pdp_product-options--loader sps2-pdp_product-options--loader_overlay"
                    style={{ height: tableHeight }}
                >
                    <Spinner />
                </div>
            )}
            {productOptions?.length > 0 && (
                <div ref={tableRef}>
                    <DataTable.Table
                        columns={desktopCols}
                        data={desktopData}
                        disableHeader={false}
                        sort={true}
                        sticky={true}
                        stickyColumns={freezeColumns}
                        percentageBase={false}
                        containerStyle={tableContainerStyle}
                        pageLength={matchingProductOptions}
                        pagTotalItems={matchingProductOptions}
                        allowFilters={true}
                    />
                </div>
            )}
            <div className="sps2-pdp_product-options--actions">
                <button
                    className="sps2-pdp_no-style-btn"
                    onClick={handleCloseProductOptions}
                >
                    <span className="mds-link_primary">{translations.closeSection}</span>{' '}
                    -
                </button>
                <p>{matchingText}</p>
            </div>
        </>
    )
}

export default ProductOptionsDesktop
